import { getMessages } from './getMessages';
import { synchronizationMessages } from './synchronizationMessages';
import { BLOB_ID } from '../../constants/blobId';
import { TThunkAction } from '../../types/redux/thunk';

/**
 * Обновление сообщений текущего чата
 */
export const updateMessages =
  (chatId: string, isOnlyCheckUpdate?: boolean): TThunkAction<Promise<void>> =>
  async (dispatch, getState) => {
    const state = getState();

    const { openedChats } = state;

    const currentChat = openedChats[chatId];

    if (chatId === BLOB_ID) {
      return;
    }

    if (isOnlyCheckUpdate) {
      dispatch(synchronizationMessages(chatId, isOnlyCheckUpdate));

      return;
    }

    if (currentChat && currentChat.chatMessages.length > 0) {
      dispatch(synchronizationMessages(chatId));

      return;
    } else {
      dispatch(getMessages(chatId));

      return;
    }

    return;
  };
